export type SamplePrompt = {
  n: number;
  title: string;
  text: string;
  tips: string[];
};

export const aiTargets = [
  { name: 'ChatGPT', url: (q: string) => `https://chatgpt.com/?q=${encodeURIComponent(q)}` },
  { name: 'Claude', url: (q: string) => `https://claude.ai/new?q=${encodeURIComponent(q)}` },
  { name: 'Gemini', url: () => 'https://gemini.google.com/app' },
  { name: 'DeepSeek', url: () => 'https://chat.deepseek.com/' },
];

export const howSteps = [
  {
    title: 'Vous choisissez le prompt',
    desc: 'Exemple : Rapport d’intervention — structure chronologique',
    chips: [] as string[],
  },
  {
    title: 'Vous remplissez les informations',
    desc: 'Les champs sont clairement indiqués :',
    chips: ['[DATE]', '[HEURE]', '[LIEU]', '[PERSONNES CONCERNÉES]', '[OBSERVATIONS]', '[ACTIONS EFFECTUÉES]', '[ÉLÉMENTS RECUEILLIS]'],
  },
  {
    title: 'Vous copiez le prompt dans votre IA',
    desc: 'Compatible avec les principaux assistants :',
    chips: ['ChatGPT', 'Claude', 'Gemini', 'DeepSeek'],
  },
  {
    title: 'L’IA produit une structure',
    desc: 'Vous obtenez une première base organisée que vous pouvez ensuite relire, corriger, compléter et valider.',
    chips: [] as string[],
  },
];

export const safeguards = [
  'Distinguer les faits des informations rapportées',
  'Identifier les informations manquantes',
  'Demander des précisions lorsque nécessaire',
  'Conserver une structure claire',
  'Vérifier les incohérences',
  'Relire le résultat avant utilisation',
];

export const samplePrompts: SamplePrompt[] = [
  {
    n: 1,
    title: 'Rapport d’intervention — structure chronologique',
    text: `Agissez comme un assistant de rédaction professionnelle spécialisé dans la structuration de rapports opérationnels. À partir des informations que je fournis, organisez les éléments de manière chronologique, objective et claire. N’ajoutez aucun fait qui ne figure pas dans mes informations. Signalez les éléments manquants ou nécessitant une vérification avant de finaliser le document.

Informations à compléter :
Date et heure : [DATE ET HEURE]
Lieu : [LIEU]
Unité / service : [UNITÉ / SERVICE]
Personnes concernées : [PERSONNES CONCERNÉES]
Faits observés : [FAITS OBSERVÉS]
Actions réalisées : [ACTIONS RÉALISÉES]
Éléments recueillis : [ÉLÉMENTS RECUEILLIS]
Résultat de l’intervention : [RÉSULTAT DE L’INTERVENTION]`,
    tips: [
      'Les dates correspondent-elles aux informations disponibles ?',
      'La chronologie est-elle cohérente ?',
      'Les personnes et lieux sont-ils correctement identifiés ?',
      'Les informations ont-elles été fournies ou déduites ?',
      'Des éléments importants sont-ils encore manquants ?',
      'Le document correspond-il réellement aux faits connus ?',
    ],
  },
];
